import Vue from 'vue'
import Vuex from 'vuex'

import login from './login'
import admin from './admin'
import cUser from './c-user'
import supplier from './supplier'
import language from './language'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    login,
    admin,
    supplier,
    cUser,
    language
  }
})
